/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import z from "zod";

export enum LinkedinRequestKey {
    isLinkedinPremiumV2 = "custom-invitation-compose-view",
    jobSeeker = "open-to-cards-by-top-card",
    getGroup = "com.linkedin.voyager.dash.deco.groups.GroupDetailPage",
    getGroups = "fetch-group-listing-page",
    invitations = "invitation-views-by-received",
    creatorExperienceDashboard = "get-creator-dashboard",
    personalInfo = "web-top-card-core-query",
    regularProfile = "web-top-card-core-query",
    featurePremiumAccess = "feature-access",
    fetchPendingInvitation = "invitation-views-by-received",
    filtersRegularSearch = "search-filter-cluster-collection",
    getRegularProfileTopCard = "top-card-supplementary-query",
    getIdentityDashProfile = "profile-cards-by-initial-cards",
    getMyEvents = "search-cluster-collection",
    searchGif = "search-third-party-media",
    searchPeople = "messaging-typeahead-by-keyword-and-types",
    getLinkedinPost = "single-update-by-backend-urn-or-nss",
    getProfessionnalEvent = "com.linkedin.voyager.dash.deco.events.ProfessionalEventDetailPage",
    getConnections = "com.linkedin.voyager.dash.deco.web.mynetwork.ConnectionListWithProfile",
    getCountryRegionGeoUrn = "search-reusable-typeahead-collection-finder-type-query",
    getIndustryId = "search-reusable-typeahead-collection-finder-type-query",
    viewersAsRegularFullView = "get-premium-dash-analytics-card",
    viewersAsPremium = "analytics-object-union-collection-finder",
    advancedRegularSearchV2 = "search-lazy-loaded-actions",
    getCompany = "member-company-by-company-urns",
    getCompanyFeedPosts = "organizational-page-relevance-feed",
    getProfileFeedPosts = "get-profile-feed-posts",
    conversationData = "get-conversation-by-id",
    conversationvoyagerFeedDashUpdatesData = "get-conversation-by-id",
    conversationEvents = "get-messages-by-timestamp",
    conversationsLastEvent = "find-conversations-by-search-criteria",
    conversationsLastEventInbox = "find-conversations-by-category-v2",
    conversationIdsByMemberIds = "find-conversations-by-recipients",
    postDataFromActivityId = "single-update-by-backend-urn-or-nss",
    postComments = "comments-by-social-detail",
    getExperiencesAndEducations = "profile-components",
    contactInfo = "profile-contact-info-finder",
    postReposts = "reshare-feed-by-reshare-feed",
}

export const executionReportSchema = z.union([
    z.object({
        executionSuccess: z.literal(true),
    }),
    z.object({ executionFailure: z.literal(true) }),
    z.object({ parsingFailure: z.literal(true) }),
]);
